import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { TagService } from '../services/tag.service';
import { TagCategory } from '../models/tag-category.model';
import { Tag } from '../models/tag.model';

@Component({
    selector: 'tag-bar',
    templateUrl: './tag-bar.component.html',
    styleUrls: ['./tag-bar.component.scss']
})

export class TagBarComponent implements OnInit {

    @Input() selectedTagCategories: TagCategory[];
    @Input() exceedTagMax: boolean;

    constructor(
       private tagService: TagService
       
        ) {
    }

    saveInputExpanded: boolean = false;
    saveTabIndex:number = -1;
    tagUpdatedSubscription;

    //savedTagsURL:string = "https://stamps.umich.edu/saved/";
    
    ngOnInit() {
        this.tagUpdatedSubscription = this.tagService.tagUpdated.subscribe(item => this.tagUpdated(item));
        //console.log('savedTags',this.savedTags);
    }

    ngOnDestroy(): void{
        this.tagUpdatedSubscription.unsubscribe();
    }

    tagUpdated(exceedMax): void{
        if(exceedMax){
            this.exceedTagMax = true;
        } else{
            this.exceedTagMax = false;
        }
    }

    toggleSave(): void{
        this.saveInputExpanded = !this.saveInputExpanded;
        if(this.saveInputExpanded){
            this.saveTabIndex = 0;
        } else{
            this.saveTabIndex = -1;
        }
    }

    /*ngDoCheck() {
        console.log('ngDoCheck');
        this.selectedTagCategories.forEach((tagCat, index, array) => {
             if (tagCat.tagSelectedCount !== tagCat.oldTagSelectedCount) {
                this.changeDetected = true;
                console.log('it changed');
                //this.changeLog.push(`DoCheck: Hero name changed to "${this.hero.name}" from "${this.oldHeroName}"`);
                tagCat.oldTagSelectedCount = tagCat.tagSelectedCount;
            }
        });
    

        if (this.changeDetected) {
            this.noChangeCount = 0;
        } else {
            // log that hook was called when there was no relevant change.
            let count = this.noChangeCount += 1;
            let noChangeMsg = `DoCheck called ${count}x when no change to hero or power`;
            if (count === 1) {
                // add new "no change" message
                //this.changeLog.push(noChangeMsg);
            } else {
                // update last "no change" message
                //this.changeLog[this.changeLog.length - 1] = noChangeMsg;
            }
        }

        this.changeDetected = false;
    }*/

    categoryHasSelectedTags(tagCategory: TagCategory): boolean {
        //console.log(tagCategory.tags.find(tag => tag.selected));
        if(tagCategory.tags.findIndex(tag => tag.selected) > -1){
            return true
        } else{
            return false;
        }   
    }

    get getSavedTagURL(): string {
        let idString = this.tagService.savedTags.toString();
        return this.tagService.savedTagsURL + idString;
    }

    get hasAnySelectedTags(): boolean {
        let hasAnySelectedTags = false;
        this.selectedTagCategories.forEach((tagCat, index, array) => {
             if(tagCat.tags.findIndex(tag => tag.selected) > -1){
                 hasAnySelectedTags = true;
            }
        });
        return hasAnySelectedTags;
    }
}



// WEBPACK FOOTER //
// C:/dev/um.stamps/src/app/shared/tag-bar/tag-bar.component.ts